// extracted by mini-css-extract-plugin
export default {"body":"body__bU8+X","content":"content__ls9Br","header":"header__pClgK","widget":"widget__a53tF"};